<template>
  <div>
    <el-dialog title="生产排程" :visible.sync="visible" width="80%" @close="close">
      <div>
        <div>
          <span class="title">机组：</span>
          <el-select
            clearable
            style="max-width: 180px"
            @change="loadList"
            filterable
            v-model="schedulingFactoryModelId"
            size="small"
            maxlength="16"
            placeholder="机组"
          >
            <el-option
              v-for="item in workershopList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </div>
        <div class="main">
          <div class="left">
            <table>
              <thead class="thead-dark">
                <tr>
                  <th>订单号</th>
                  <th>物料名称</th>
                  <th>消耗时长</th>
                  <th>时差</th>
                </tr>
              </thead>
              <draggable
                class="list-group"
                v-model="taskListL"
                tag="tbody"
                group="task"
                @end="computeFinishTime"
              >
                <tr v-for="(item, index) in taskListL" :key="index">
                  <td>
                    {{ item.productionBatchCode }}
                  </td>
                  <td>
                    {{ item.materialName }}
                  </td>
                  <td>
                    {{ item.consumeDuration }}
                  </td>
                  <td>
                    {{ item.timeDifference }}
                  </td>
                </tr>
              </draggable>
            </table>
          </div>
          <div class="right">
            <table style="height: 100%">
              <thead class="thead-dark">
                <th style="width: 110px">订单号</th>
                <th style="width: 160px">物料名称</th>
                <th style="width: 60px">消耗时长</th>
                <th style="width: 60px">时差</th>
                <th style="width: 110px">订单当前状态</th>
                <th style="width: 100px">规格</th>
                <th style="width: 60px">订单教量</th>
                <th style="width: 60px">件数</th>
                <th style="width: 60px">完工数量</th>
                <th style="width: 140px">预计完成时间</th>
                <th style="width: 140px">计划完工时间</th>
              </thead>

              <draggable
                v-for="(item, index) in group"
                draggable=".drag"
                :key="index"
                class="list-groupR"
                v-model="item.list"
                tag="tbody"
                group="task"
                @end="computeFinishTime"
              >
                <tr
                  v-for="task in item.list"
                  :key="task.id"
                  :class="task.productionState == 1 ? 'drag' : ''"
                  :style="task.productionState == 1 ? '' : 'cursor: no-drop'"
                >
                  <td style="width: 110px">
                    {{ task.productionBatchCode }}
                  </td>
                  <td style="width: 160px">
                    {{ task.materialName }}
                  </td>
                  <td style="width: 60px">
                    {{ task.consumeDuration }}
                  </td>
                  <td style="width: 60px">
                    {{ task.timeDifference }}
                  </td>
                  <td style="width: 110px">
                    {{ $parent.parseProductionState(task) }}
                  </td>
                  <td style="width: 100px">{{ task.specification }}</td>
                  <td style="width: 60px">{{ task.splitCount }}</td>
                  <td style="width: 60px">{{ task.auxQty }}</td>
                  <td style="width: 60px">{{ task.finishedQty }}</td>
                  <td style="width: 140px">{{ task.finishTime }}</td>
                  <td style="width: 140px">{{ task.planEndTime }}</td>
                </tr>
                <!-- <el-button class="del" type="text" @click="delOne(item, index)">删除</el-button> -->
                <i class="el-icon-circle-plus addGroup" @click="addOne(item, index)"></i>
                <i class="el-icon-error del" @click="delOne(item, index)"></i>
              </draggable>

              <tbody class="add" @click="group.push({ list: [], showDel: false })">
                <i class="el-icon-plus"></i>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submint">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { add, format } from "date-fns";
export default {
  name: "schedulingDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    workershopList: {
      type: Array,
      default: () => [],
    },
    productionStateOption: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    draggable,
  },
  data() {
    return {
      schedulingFactoryModelId: "",
      taskListL: [],
      group: [{ showDel: false, list: [] }],
    };
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        if (this.workershopList[0]) {
          this.schedulingFactoryModelId = this.workershopList[0].id;
          this.loadList(this.workershopList[0].id);
        } else {
          this.$message.error("无机组数据");
        }
      }
    },
    // group(newValue, oldValue) {
    //   this.$nextTick(() => {
    //     const egroup = document.getElementsByClassName("list-groupR");
    //     Array.from(egroup).forEach((element, index) => {
    //       element.addEventListener("mouseover", () => {
    //         this.group[index].showDel = true;
    //       });
    //       element.addEventListener("mouseleave", () => {
    //         this.group[index].showDel = false;
    //       });
    //     });
    //   });
    // }
  },
  mounted() {},
  methods: {
    loadList(factoryModelId) {
      this.getUnscheduledList(factoryModelId);
      this.getScheduledList(factoryModelId);
    },
    getUnscheduledList(factoryModelId) {
      this.group = [{ list: [] }];
      if (factoryModelId) {
        this.$RequestUtil.get({
          url: "/api/production-order-item/unscheduled-list",
          params: {
            factoryModelId,
          },
          success: (res) => {
            if (res.code == 0) {
              this.taskListL = res.data;
            }
          },
        });
      }
    },

    getScheduledList(factoryModelId) {
      if (factoryModelId) {
        this.$RequestUtil.get({
          url: "/api/production-order-item/list",
          params: {
            factoryModelId,
          },
          success: (res) => {
            let map = {};
            if (res.code == 0) {
              res.data.forEach((e) => {
                if (map[e.orderGroup]) {
                  map[e.orderGroup].push(e);
                } else {
                  map[e.orderGroup] = [e];
                }
                // if (!this.group[e.orderGroup - 1]) {
                //   this.$set(this.group, e.orderGroup - 1, { list: [e] });
                //   // this.group[e.orderGroup - 1] = { list: [e] };
                // } else {
                //   this.group[e.orderGroup - 1].list.push(e);
                // }
              });
              var keys = Object.keys(map);
              keys.forEach((key, index) => {
                map[key].forEach((e) => {
                  e.orderGroup = index + 1;
                });
                this.$set(this.group, index, { list: map[key] });
              });
            }
          },
        });
      }
    },

    showDel(item) {
      console.log(item);
      item.showDel = true;
    },
    delOne(row, index) {
      let falg = true;
      row.list.forEach((e) => {
        if (e.productionState != 1) {
          this.$message.error("无法操作进行中的订单");
          falg = false;
        }
      });
      if (falg) {
        this.taskListL = this.taskListL.concat(row.list);
        this.group.splice(index, 1);
      }
    },
    addOne(row, index) {
      this.group.splice(index + 1, 0, { list: [], showDel: false });
    },
    onEnd(evt) {},
    computeFinishTime() {
      console.log(1);
      const now = new Date();
      let maxTime = now;
      let groupStartTime = now;
      this.group.forEach((g) => {
        groupStartTime = maxTime;
        g.list.forEach((task) => {
          let finishTime = add(groupStartTime, { hours: task.consumeDuration });
          let outTime = add(finishTime, { hours: task.timeDifference });
          if (maxTime < outTime) {
            maxTime = outTime;
          }
          task.finishTime = format(finishTime, "yyyy-MM-dd HH:mm:ss");
        });
      });
    },
    submint() {
      const itemList = [];
      const arr = this.group.filter((e) => e.list.length != 0);
      arr.forEach((g, index) => {
        g.list.forEach((task) => {
          task.orderGroup = index + 1;
          // task.finishTime = task.finishTime.replace(" ", "T");
          itemList.push(task);
        });
      });
      this.$RequestUtil.post({
        url: "/api/production-order-item/submit",
        params: {
          factoryModelId: this.schedulingFactoryModelId,
          itemList,
        },
        success: (res) => {
          if (res.code == 0) {
            this.$message({ type: "success", message: "操作成功" });
          }
        },
      });
    },
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped>
.main {
  display: flex;
}
.main > div {
  border: 1px solid #ccc;
  margin: 20px;
}
.list-group {
  height: 372px;
  display: block;
  overflow: auto;
}
.list-groupR {
  min-height: 60px;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin: 10px 30px;
}
.add {
  min-height: 60px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  margin: 10px 30px;
  cursor: pointer;
  text-align: center;
  line-height: 60px;
  font-size: 24px;
}
.del {
  position: absolute;
  left: -20px;
  color: rgb(244, 91, 91);
  /* right: -20px; */
  top: 0;
  cursor: pointer;
}
.addGroup {
  position: absolute;
  left: -20px;
  color: #66b1ff;
  /* right: -20px; */
  top: 20px;
  cursor: pointer;
}
.left {
  width: 300px;
  height: 400px;
}
.left th {
  width: 75px;
  text-align: center;
}
.left td {
  width: 75px;
  text-align: center;
}
tr {
  display: block;
  line-height: 20px;
}
.right {
  width: 1160px;
  height: 400px;
}
.right th {
  width: 90px;
  text-align: center;
}
.right td {
  width: 90px;
  text-align: center;
}
.right tr {
  cursor: pointer;
}
.right thead {
  display: block;
  margin: 0 30px;
  width: 1100px;
}
.right tbody {
  width: 1100px;
  display: block;
  position: relative;
}
.right table {
  display: block;
  overflow: auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/order/ProductionTask/SchedulingDialog.vue